import TextInput from '@/atoms/forms/Input';
import { BankAccountFields } from './types';
import { friendlyFormatIBAN } from 'ibantools';

const BankAccountTypeFields = ({ type }: { type: string }) => {
  switch (type) {
    case 'IBAN':
      return (
        <>
          <TextInput
            label="bank-account-iban"
            name={BankAccountFields.IBAN}
            placeholder="bank-account-iban"
            transform={{
              output: (event) => {
                const extractedIban = friendlyFormatIBAN(event.target.value);

                if (extractedIban) {
                  // eslint-disable-next-line no-param-reassign
                  event.target.value = extractedIban;
                }

                return event;
              },
            }}
            type="text"
          />
          <TextInput
            label="bank-account-bic"
            name={BankAccountFields.BIC}
            placeholder="bank-account-bic"
            transform={{
              output: (event) => {
                const extractedIban = event.target.value?.replaceAll(' ', '');

                if (extractedIban) {
                  // eslint-disable-next-line no-param-reassign
                  event.target.value = extractedIban;
                }

                return event;
              },
            }}
            type="text"
          />
        </>
      );
    case 'US':
      return (
        <>
          <TextInput
            label="bank-account-number"
            name={BankAccountFields.accountNumber}
            placeholder="bank-account-number"
            type="text"
          />
          <TextInput label="bank-account-aba" name={BankAccountFields.ABA} placeholder="bank-account-aba" type="text" />
        </>
      );
    case 'CA':
      return (
        <>
          <TextInput
            label="bank-account-number"
            name={BankAccountFields.accountNumber}
            placeholder="bank-account-number"
            type="text"
          />
          <TextInput
            label="bank-account-institution-number"
            name={BankAccountFields.institutionNumber}
            placeholder="bank-account-institution-number"
            type="text"
          />
          <TextInput
            label="bank-account-branch-code"
            name={BankAccountFields.branchCode}
            placeholder="bank-account-branch-code"
            type="text"
          />
          <TextInput
            label="bank-account-bank-name"
            name={BankAccountFields.bankName}
            placeholder="bank-account-bank-name"
            type="text"
          />
        </>
      );
    case 'GB':
      return (
        <>
          <TextInput
            label="bank-account-number"
            name={BankAccountFields.accountNumber}
            placeholder="bank-account-number"
            type="text"
          />
          <TextInput
            label="bank-account-sort-code"
            name={BankAccountFields.sortCode}
            placeholder="bank-account-sort-code"
            type="text"
          />
        </>
      );
    case 'OTHER':
    default:
      return (
        <>
          <TextInput
            label="bank-account-number"
            name={BankAccountFields.accountNumber}
            placeholder="bank-account-number"
            type="text"
          />
          <TextInput label="bank-account-bic" name={BankAccountFields.BIC} placeholder="bank-account-bic" type="text" />
        </>
      );
  }
};

export default BankAccountTypeFields;
